/**
 * @generated SignedSource<<6c63fcba7771866b70ceff498e8945e3>>
 * @relayHash 2be3a685bbf581660d9305132edd3fa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a9208ff4b3164a9b8ba3153f748f6f3390caaa21b7be4e4fd2d1e659518f4b6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FirstCreateViewQuery } from './FirstCreateViewQuery.graphql';

const node: PreloadableConcreteRequest<FirstCreateViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6a9208ff4b3164a9b8ba3153f748f6f3390caaa21b7be4e4fd2d1e659518f4b6",
    "metadata": {},
    "name": "FirstCreateViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
